import React from 'react';


interface ContainerProps {
    color?: string;
    height?: number;
    selected: boolean;
}
interface Props extends ContainerProps { };
const Radio: React.FC<Props> = (props) => {
    const { color, selected } = props;

    const height = props.height || 17;

    return (
        <div id="Radio" className={`${color}`}>
            <div className="d-flex justify-content-center align-items-center" style={{ height, width: height }}>
                {selected && (<div style={{ height: height - 9, width: height - 9 }} />)}
            </div>
        </div>
    )
}

export default Radio;